// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".eHncOxl2T4eFo95h6QvP svg{cursor:pointer;color:#9996f8;margin-left:8px;position:relative;top:4px}", "",{"version":3,"sources":["webpack://./src/common/components/CopyableLinkableContent/component.module.scss"],"names":[],"mappings":"AACE,0BACE,cAAA,CACA,aAAA,CACA,eAAA,CACA,iBAAA,CACA,OAAA","sourcesContent":[".main {\n  svg {\n    cursor: pointer;\n    color: #9996f8;\n    margin-left: 8px;\n    position: relative;\n    top: 4px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": "eHncOxl2T4eFo95h6QvP"
};
export default ___CSS_LOADER_EXPORT___;
